/**
 * 懒加载图片标识集合（存储图片URL等唯一值）
 */
class LazyImgLoadedSet {
  private lazyImgList: Set<string> = new Set()
  readonly maxSize: number = 1000

  hasLazyImg(url: string) {
    return this.lazyImgList.has(url)
  }

  addLazyImg(url: string) {
    if (this.hasLazyImg(url)) return

    // 超过容量时，删除最旧的元素（FIFO 策略，避免内存溢出）
    if (this.lazyImgList.size >= this.maxSize) {
      const oldestUrl = this.lazyImgList.keys().next().value
      this.lazyImgList.delete(oldestUrl)
    }
    this.lazyImgList.add(url)
  }

  /**
   * 清空所有懒加载图片记录（全局清理）
   */
  clearAllLazyImgs = () => {
    this.lazyImgList.clear()
  }
}

const lazyImgLoadedSet = new LazyImgLoadedSet()

export default lazyImgLoadedSet
